import { t } from '@lingui/core/macro';

/*
 * Enumeration of available user role groups
 */
export enum UserRoles {
  admin = 'admin',
  bom = 'bom',
  build = 'build',
  ncr = 'ncr',
  part = 'part',
  part_category = 'part_category',
  pricing = 'pricing',
  purchase_order = 'purchase_order',
  return_order = 'return_order',
  transfer_order = 'transfer_order',
  sales_order = 'sales_order',
  stock = 'stock',
  stock_location = 'stock_location'
}

/*
 * Enumeration of available user permissions within each role group
 */
export enum UserPermissions {
  view = 'view',
  add = 'add',
  change = 'change',
  delete = 'delete'
}

export function userRoleLabel(role: UserRoles): string {
  switch (role) {
    case UserRoles.admin:
      return t`Admin`;
    case UserRoles.build:
      return t`Build Orders`;
    case UserRoles.ncr:
      return t`Non-Conformances`;
    case UserRoles.part:
      return t`Parts`;
    case UserRoles.part_category:
      return t`Part Categories`;
    case UserRoles.pricing:
      return t`Pricing`;
    case UserRoles.purchase_order:
      return t`Purchase Orders`;
    case UserRoles.return_order:
      return t`Return Orders`;
    case UserRoles.transfer_order:
      return t`Transfer Orders`;
    case UserRoles.sales_order:
      return t`Sales Orders`;
    case UserRoles.stock:
      return t`Stock Items`;
    case UserRoles.stock_location:
      return t`Stock Location`;
    default:
      return role as string;
  }
}

export const roleToViewSettingMap: Partial<Record<UserRoles, string>> = {
  [UserRoles.build]: 'BUILDORDER_ENABLED',
  [UserRoles.ncr]: 'NCR_ENABLED',
  [UserRoles.sales_order]: 'SALESORDER_ENABLED',
  [UserRoles.purchase_order]: 'PURCHASEORDER_ENABLED',
  [UserRoles.transfer_order]: 'TRANSFERORDER_ENABLED',
  [UserRoles.return_order]: 'RETURNORDER_ENABLED'
};
